import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

const campaignValue = z.string().trim().max(200).optional();
const touchSchema = z.object({
  captured_at: z.string().datetime(),
  utm_source: campaignValue,
  utm_medium: campaignValue,
  utm_campaign: campaignValue,
  utm_content: campaignValue,
  utm_term: campaignValue,
  utm_id: campaignValue,
  landing_page: campaignValue,
  landing_host: campaignValue,
  referrer: campaignValue,
});
export const analyticsContextSchema = z.object({
  consent: z.enum(["granted", "denied"]),
  clientId: z
    .string()
    .regex(/^\d{1,20}\.\d{1,20}$/)
    .optional(),
  sessionId: z
    .string()
    .regex(/^\d{1,20}$/)
    .optional(),
  firstTouch: touchSchema.optional(),
  latestCampaign: touchSchema.optional(),
});

export class AnalyticsContextDto extends createZodDto(analyticsContextSchema) {}
